export const platf = [
    "PC",
    "PlayStation 5",
    "PlayStation 4",
    "Xbox One",
    "Xbox Series S/X",
    "Nintendo Switch",
    "iOS",
    "Android",
    "Nintendo 3DS",
    "Nintendo DS",
    "Nintendo DSi",
    "macOS",
    "Linux",
    "Xbox 360",
    "Xbox",
    "PlayStation 3",
    "PlayStation 2",
    "PlayStation",
    "PS Vita",
    "PSP",
    "Wii U",
    "Wii",
    "GameCube",
    "Nintendo 64",
    "Game Boy Advance",
    "Game Boy Color",
    "Game Boy",
    "SNES",
    "NES",
    "Classic Macintosh",
    "Apple II",
    "Commodore / Amiga",
    "Atari 7800",
    "Atari 5200",
    "Atari 2600",
    "Atari Flashback",
    "Atari 8-bit",
    "Atari ST",
    "Atari Lynx",
    "Atari XEGS",
    "Genesis",
    "SEGA Saturn",
    "SEGA CD",
    "SEGA 32X",
    "SEGA Master System",
    "Dreamcast",
    "3DO",
    "Jaguar",
    "Game Gear",
    "Neo Geo",
    "Web",
  ];

//   export function validate(input){
//     let error = {};
//     if(!input.name ){
//         error.name = '*This field is required.'
//     }
//     if(!input.image===("https://" || "http://") || !input.image===(".jpg" || ".png" || ".gif")){
//         error.image = "*Enter a valid URL (.jpg, .png, .gif)"
//     }
//     if(!input.description && input.description.length<1){
//         error.description ='*Please enter a description'
//     }
//     if(!input.releases && input.length<1){
//         if(!/^\d{4}-(0?[1-9]|1[012])-(0?[1-9]|[12][0-9]|3[01])$/.test(input.released)){
//              error.released = '*Error.';
//             }
  
//     }if(!input.rating && input.rating <= 0 || input.rating > 5){
//             error.rating = '*Error, the rating must be between 0 and 5'
//     }if(!input.genres.length && !input.genres.length<1){
//             error.genres = '*This field is required'
//     }if(!input.platforms.length && !input.platforms.length<1){
//         error.platforms = '*This field is required'
//     }
//     return error;
//   };
  